

































import type { PropType } from '@nuxtjs/composition-api';
import { computed, defineComponent } from '@nuxtjs/composition-api';
import { SfTabs } from '@storefront-ui/vue';

import HTMLContent from '~/components/HTMLContent.vue';
import { TabsConfig } from '~/modules/catalog/product/composables/useProductTabs';
import type { Product } from '~/modules/catalog/product/types';

export default defineComponent({
  name: 'ProductTabs',
  components: {
    HTMLContent,
    SfTabs
  },
  props: {
    product: {
      type: [Object, null] as PropType<Product | null>,
      default: null
    },
    openTab: {
      type: Number,
      default: TabsConfig.description.ID
    },
    tabsId: {
      type: String,
      default: ''
    }
  },
  setup(props, { emit }) {
    const changeTab = (tabNumber: number) => {
      if (!process.client) return props.openTab;
      const tabs = document.querySelector(props.tabsId);

      if (!tabs) return props.openTab;
      tabs.scrollIntoView({
        block: 'start',
        behavior: 'smooth'
      });
      emit('changeTab', tabNumber);
      return tabNumber;
    };

    const activeTab = computed(() => changeTab(props.openTab));

    const productDescription = computed(
      () => props.product?.description?.html || ''
    );

    return {
      activeTab,
      changeTab,
      productDescription
    };
  }
});
